import Api from "@/helpers/api.js";
import * as constants from "@/constants";
/**
 * Get all clustering records
 * @param {Object} payload - Search filters
 * @returns {Promise} API response with clustering list
 */
export const getClusters = (payload = {}) => {
	return Api.post(constants.API_CLUSTER_URL + "/clustering/search", payload);
};

/**
 * Create a new clustering
 * @param {Object} payload - Clustering data {name, total_clusters, total_micro_clusters, points}
 * @returns {Promise} API response with created clustering
 */
export const createClustering = (payload) => {
	return Api.post(constants.API_CLUSTER_URL + "/clustering/create", payload);
};

/**
 * Update an existing clustering
 * @param {Object} payload - Clustering data to update
 * @returns {Promise} API response with updated clustering
 */
export const updateClustering = (payload) => {
	return Api.post(constants.API_CLUSTER_URL + "/clustering/update", payload);
};

/**
 * Delete a clustering by ID
 * @param {Object} payload - {id: id}
 * @returns {Promise} API response confirming deletion
 */
export const deleteClustering = (payload) => {
	return Api.post(constants.API_CLUSTER_URL + "/clustering/delete", payload);
};

/**
 * Get clustering by ID
 * @param {Number|String} id - Clustering ID
 * @returns {Promise} API response with clustering details
 */
export const getClusteringById = (payload) => {
	return Api.post(constants.API_CLUSTER_URL + "/clustering/get_file", payload);
};
